import { createTheme } from '@mui/material'

const homeTheme = createTheme({
  palette: {
    background: {
      default: '#f9fafc',
      input: '#f4f6f9',
      paper: '#ffffff',
    },
    primary: {
      light: '#4dabf5',
      main: '#2196f3',
      dark: '#1769aa',
    },
  },
})

export default homeTheme
